import React from "react";
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const GraphsWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/costLeadsAnalytics/analytics/graphs/GraphsWrap')
)

const MessageLogsWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/costLeadsAnalytics/analytics/messageLogs/MessageLogsWrap')
)

const CampaignAnalyticsRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/campaign-lead-track/:id/analytics' component={GraphsWrap} />
    {/* <Route exact path='/marketing-blast/campaign-lead-track/:id/message-logs' component={MessageLogsWrap} /> */}
    <Route exact path='/marketing-blast/campaign-lead-track/:id/email-logs' component={MessageLogsWrap} />
    <Route exact path='/marketing-blast/campaign-lead-track/:id/sms-logs' component={MessageLogsWrap} />

    <Route exact path='/marketing-blast/campaign-lead-track/log/:id/analytics' component={GraphsWrap} />
    {/* <Route exact path='/marketing-blast/campaign-lead-track/log/:id/message-logs' component={MessageLogsWrap} /> */}
    <Route exact path='/marketing-blast/campaign-lead-track/log/:id/email-logs' component={MessageLogsWrap} />
    <Route exact path='/marketing-blast/campaign-lead-track/log/:id/sms-logs' component={MessageLogsWrap} />
  </Switch>
)

export default CampaignAnalyticsRoutes;